import { pipe } from 'ramda';
import { Content } from 'stores/core';
import { ProjectsReport, ProjectsReportRecord } from '../../types';
import { WidgetState } from '../state';
import { getAverageCSATReceived } from './average-csat';
import { getAverageHoursDifference } from './average-hours-difference';
import { getAverageProjectsEndingDelay } from './average-project-ending-delay';
import { getAverageProjectsStartingDelay } from './average-project-starting-delay';
import { getPhaseCompletedOnTime } from './phases-completed-on-time';
import { getProjectsEndedOnTime } from './projects-ended-on-time';
import { getProjectsStartedOnTime } from './projects-started-on-time';
import { getTasksCompletedOnTime } from './tasks-completed-on-time';

export type WidgetStateError = 'error';

interface WidgetData {
  phasesCompletedOnTime: WidgetState<number, WidgetStateError>;
  tasksCompletedOnTime: WidgetState<number, WidgetStateError>;
  averageProjectCsat: WidgetState<number, WidgetStateError>;
  projectsStartedOnTime: WidgetState<number, WidgetStateError>;
  averageProjectsStartingDelay: WidgetState<number, WidgetStateError>;
  projectsEndedOnTime: WidgetState<number, WidgetStateError>;
  averageProjectsEndingDelay: WidgetState<number, WidgetStateError>;
  averageHoursDifference: WidgetState<number, WidgetStateError>;
}
export const useWidgetData = (projectsReport: ProjectsReport): WidgetData => {
  const records = pipe(
    () => projectsReport,
    Content.map((x) => x),
    Content.orElse([] as ProjectsReportRecord[]),
  )();

  return {
    phasesCompletedOnTime: getPhaseCompletedOnTime(records),
    tasksCompletedOnTime: getTasksCompletedOnTime(records),
    averageProjectCsat: getAverageCSATReceived(records),
    projectsStartedOnTime: getProjectsStartedOnTime(records),
    averageProjectsStartingDelay: getAverageProjectsStartingDelay(records),
    projectsEndedOnTime: getProjectsEndedOnTime(records),
    averageProjectsEndingDelay: getAverageProjectsEndingDelay(records),
    averageHoursDifference: getAverageHoursDifference(records),
  };
};
